export const actionTypes = {
  USER_ACCOUNT_REQUEST_RESET_PASSWORD: "USER_ACCOUNT_REQUEST_RESET_PASSWORD",
  USER_ACCOUNT_REQUEST_RESET_PASSWORD_SUCCESS:
    "USER_ACCOUNT_REQUEST_RESET_PASSWORD_SUCCESS",
  USER_ACCOUNT_REQUEST_RESET_PASSWORD_FAILURE:
    "USER_ACCOUNT_REQUEST_RESET_PASSWORD_FAILURE",
  RESET_PASSWORD_REQUEST: "RESET_PASSWORD_REQUEST",
  RESET_PASSWORD_REQUEST_SUCCESS: "RESET_PASSWORD_REQUEST_SUCCESS",
  RESET_PASSWORD_REQUEST_FAILURE: "RESET_PASSWORD_REQUEST_FAILURE",

  FORCED_RESET_PWD: "FORCED_RESET_PWD",
  FORCED_RESET_PWD_SUCCESS: "FORCED_RESET_PWD_SUCCESS",
  FORCED_RESET_PWD_FAILURE: "FORCED_RESET_PWD_FAILURE",

  RESET_STATE: "RESET_STATE",
  GET_RESET_PWD_QUESTIONS: "GET_RESET_PWD_QUESTIONS",
  GET_RESET_PWD_QUESTIONS_SUCCESS: "GET_RESET_PWD_QUESTIONS_SUCCESS",
  GET_RESET_PWD_QUESTIONS_FAILURE: "GET_RESET_PWD_QUESTIONS_FAILURE",

  GENERATE_UIGP_OTP_REQUEST: "GENERATE_UIGP_OTP_REQUEST",
  GENERATE_UIGP_OTP_REQUEST_SUCCESS: "GENERATE_UIGP_OTP_REQUEST_SUCCESS",
  GENERATE_UIGP_OTP_REQUEST_FAILURE: "GENERATE_UIGP_OTP_REQUEST_FAILURE",

  VERIFY_RESET_UIGP_OTP_REQUEST: "VERIFY_RESET_UIGP_OTP_REQUEST",
  VERIFY_RESET_UIGP_OTP_REQUEST_SUCCESS:
    "VERIFY_RESET _UIGP_OTP_REQUEST_SUCCESS",
  VERIFY_RESET_UIGP_OTP_REQUEST_FAILURE:
    "VERIFY_RESET _UIGP_OTP_REQUEST_FAILURE",

  VERIFY_RESET_ARCOT_OTP_REQUEST: "VERIFY_RESET_ARCOT_OTP_REQUEST",
  VERIFY_RESET_ARCOT_OTP_REQUEST_SUCCESS:
    "VERIFY_RESET _ARCOT_OTP_REQUEST_SUCCESS",
  VERIFY_RESET_ARCOT_OTP_REQUEST_FAILURE:
    "VERIFY_RESET _ARCOT_OTP_REQUEST_FAILURE",

  VERIFY_RESET_SEC_QUESTIONS: "VERIFY_RESET_SEC_QUESTIONS",
  VERIFY_RESET_SEC_QUESTIONS_SUCCESS: "VERIFY_RESET_SEC_QUESTIONS_SUCCESS",
  VERIFY_RESET_SEC_QUESTIONS_FAILURE: "VERIFY_RESET_SEC_QUESTIONS_FAILURE",
};

export const forcedResetRequestAction = (payload: any) => {
  return {
    type: actionTypes.FORCED_RESET_PWD,
    payload,
  };
};
export const forcedResetRequestActionSuccess = (payload: any) => {
  return {
    type: actionTypes.FORCED_RESET_PWD_SUCCESS,
    payload,
  };
};
export const forcedResetRequestActionFailure = (error: any) => {
  return {
    type: actionTypes.FORCED_RESET_PWD_FAILURE,
    error,
  };
};

export const generateOtpRequest = (payload: any) => {
  return {
    type: actionTypes.GENERATE_UIGP_OTP_REQUEST,
    payload,
  };
};
export const generateOtpRequestSuccess = (payload: any) => {
  return {
    type: actionTypes.GENERATE_UIGP_OTP_REQUEST_SUCCESS,
    payload,
  };
};
export const generateOtpRequestFailure = (error: any) => {
  return {
    type: actionTypes.GENERATE_UIGP_OTP_REQUEST_FAILURE,
    error,
  };
};

export const verifyResetArcotOtpAction = (payload: any) => {
  return {
    type: actionTypes.VERIFY_RESET_ARCOT_OTP_REQUEST,
    payload,
  };
};
export const verifyResetArcotOtpActionSuccess = (payload: any) => {
  return {
    type: actionTypes.VERIFY_RESET_ARCOT_OTP_REQUEST_SUCCESS,
    payload,
  };
};
export const verifyResetArcotOtpActionFailure = (error: any) => {
  return {
    type: actionTypes.VERIFY_RESET_ARCOT_OTP_REQUEST_FAILURE,
    error,
  };
};

export const verifyResetUigpOtpAction = (payload: any) => {
  return {
    type: actionTypes.VERIFY_RESET_UIGP_OTP_REQUEST,
    payload,
  };
};
export const verifyResetUigpOtpActionSuccess = (payload: any) => {
  return {
    type: actionTypes.VERIFY_RESET_UIGP_OTP_REQUEST_SUCCESS,
    payload,
  };
};
export const verifyResetUigpOtpActionFailure = (error: any) => {
  return {
    type: actionTypes.VERIFY_RESET_UIGP_OTP_REQUEST_FAILURE,
    error,
  };
};

export const userAccountRequest = () => {
  return {
    type: actionTypes.USER_ACCOUNT_REQUEST_RESET_PASSWORD,
  };
};

export const userAccountRequestSuccess = (payload: any[]) => ({
  type: actionTypes.USER_ACCOUNT_REQUEST_RESET_PASSWORD_SUCCESS,
  payload,
});

export const userAccountRequestFailure = (err: Error) => ({
  type: actionTypes.USER_ACCOUNT_REQUEST_RESET_PASSWORD_FAILURE,
  err,
});

export const getResetPwdSecurityQuestions = () => ({
  type: actionTypes.GET_RESET_PWD_QUESTIONS,
});

export const getResetPwdSecurityQuestionsSuccess = (payload: any[]) => ({
  type: actionTypes.GET_RESET_PWD_QUESTIONS_SUCCESS,
  payload,
});

export const getResetPwdSecurityQuestionsFailure = (err: Error) => ({
  type: actionTypes.GET_RESET_PWD_QUESTIONS_FAILURE,
  err,
});

export const resetPasswordRequest = (accountId: string) => ({
  type: actionTypes.RESET_PASSWORD_REQUEST,
  accountId,
});

export const resetPasswordRequestSuccess = (payload: any) => ({
  type: actionTypes.RESET_PASSWORD_REQUEST_SUCCESS,
  payload,
});

export const resetPasswordRequestFailure = (err: any) => ({
  type: actionTypes.RESET_PASSWORD_REQUEST_FAILURE,
  err,
});

export const resetState = () => ({
  type: actionTypes.RESET_STATE,
});

export const verifyResetQuestionsAction = (payload: any) => ({
  type: actionTypes.VERIFY_RESET_SEC_QUESTIONS,
  payload,
});
export const verifyResetQuestionsActionSuccess = (payload: any) => ({
  type: actionTypes.VERIFY_RESET_SEC_QUESTIONS_SUCCESS,
  payload,
});
export const verifyResetQuestionsActionFailure = (payload: any) => ({
  type: actionTypes.VERIFY_RESET_SEC_QUESTIONS_FAILURE,
  payload,
});
